import { dashboardReservationsSelector } from '../selectors'
import Reservation from './Reservation'
import { createStructuredSelector } from 'reselect'

const Header = () => (
    <div className="table-header">
        <div className="transaction">
            <T>dashboard.label.transaction</T>
        </div>
        <div className="type">
            <T>dashboard.label.type</T>
        </div>
        <div className="location">
            <T>dashboard.label.location</T>
        </div>
        <div className="start">
            <T>dashboard.label.range.s.date</T>
        </div>
        <div className="end">
            <T>dashboard.label.range.e.date</T>
        </div>
        <div className="price">
            <T>dashboard.label.price</T>
        </div>
        <div className="actions">
            <T>dashboard.label.receipt</T>
        </div>
    </div>
)

const ReservationsTable = ({ reservations, onSelectReservation }) => (
    <div className="table table-hover reservations mt-4">
        <Header />
        {reservations.map(id => (
            <Reservation reservationId={id} onClick={onSelectReservation} key={id} />
        ))}
    </div>
)

export default connect(
    createStructuredSelector({
        reservations: dashboardReservationsSelector,
    })
)(ReservationsTable)
